import './RequestInterceptor.css'
import axios from "axios";
import {useToasts} from "react-toast-notifications";
import {useState} from "react";

function useStickyState(key) {
    const [state, setState] = useState(localStorage.getItem(key))

    const setStickyState = (newState) => {
        if (!newState) {
            localStorage.removeItem(key)
            setState(null)
        } else {
            localStorage.setItem(key, newState)
            setState(newState)
        }
    }

    return [state, setStickyState]
}

export default function RequestInterceptor({children}) {
    const {addToast} = useToasts()
    const [username, setUsername] = useStickyState("username")
    const [password, setPassword] = useStickyState("password")

    if (!username || !password) {
        axios.interceptors.request.use()

        axios.interceptors.response.use()

        return (
            <div className="login-form">
                <form onSubmit={e => {
                    e.preventDefault()
                    setUsername(e.target.username.value)
                    setPassword(e.target.password.value)
                }}>
                    <h1>Connexion</h1>
                    <input name="username" placeholder="Utilisateur" autoFocus/>
                    <input name="password" placeholder="Mot de passe" type="password"/>
                    <button type="submit">Valider</button>
                </form>
            </div>
        )
    } else {
        axios.interceptors.request.use(config => {
            config.auth = {username, password}
            return config
        })

        axios.interceptors.response.use(undefined, error => {
            if (error.response?.status === 401) {
                setUsername(null)
                setPassword(null)
                window.location.reload()
            }
            if (error.response?.data?.message) return addToast(error.response.data.message, {appearance: "error"})
            return Promise.reject(error)
        })

        return children
    }

}
